
import React, { useState } from 'react';
import './UnlockModal.css';
import { Post, useApp } from '../../context/AppContext';

interface UnlockModalProps {
  post: Post;
  onClose: () => void;
}

const UnlockModal: React.FC<UnlockModalProps> = ({ post, onClose }) => {
  const { unlockContent, adminUser } = useApp();
  const [processing, setProcessing] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleUnlock = () => {
    setProcessing(true);
    setTimeout(() => {
      unlockContent(post.id);
      setSuccess(true);
      setTimeout(onClose, 1500);
    }, 1500);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="unlock-modal animate-slide-up" onClick={e => e.stopPropagation()}>
        <div className="modal-handle" />
        
        {success ? (
          <div className="unlock-success">
            <div className="success-icon">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
              </svg>
            </div>
            <h3>Content Unlocked!</h3>
            <p>Enjoy your exclusive content</p>
          </div>
        ) : (
          <>
            <div className="unlock-header">
              <div className="unlock-preview">
                <img src={post.mediaUrl} alt="Preview" />
                <div className="blur-overlay" />
                <div className="lock-badge">🔒</div>
              </div>
            </div>

            <div className="unlock-info">
              <h3>Unlock Exclusive Content</h3>
              <p>by {adminUser.displayName}</p>
              <div className="unlock-price">${post.price}</div>
            </div>

            <div className="unlock-features">
              <div className="feature">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
                Full HD quality content
              </div>
              <div className="feature">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
                Lifetime access
              </div>
              <div className="feature">
                <svg viewBox="0 0 24 24" fill="currentColor"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>
                Download enabled
              </div>
            </div>

            <button 
              className={`unlock-pay-btn ${processing ? 'processing' : ''}`} 
              onClick={handleUnlock}
              disabled={processing}
            >
              {processing ? (
                <span className="spinner" />
              ) : (
                <>
                  <svg viewBox="0 0 24 24" fill="currentColor" className="paypal-icon">
                    <path d="M7.076 21.337H2.47a.641.641 0 0 1-.633-.74L4.944 2.16A.762.762 0 0 1 5.697 1.5h6.49c2.062 0 3.624.534 4.645 1.588.963.998 1.363 2.392 1.188 4.145l-.003.028c-.253 1.612-.916 2.886-1.97 3.787-1.046.895-2.393 1.35-4.003 1.35H9.863l-.698 4.447a.637.637 0 0 1-.63.536H7.076z"/>
                  </svg>
                  Pay ${post.price} with PayPal
                </>
              )}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default UnlockModal;
